"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class exits solely to store config data in memory so that other classes can access it in a singular fashion
 */
var Bridge = /*#__PURE__*/function () {
  function Bridge() {
    _classCallCheck(this, Bridge);

    this.config = null;
    this.contextHandlers = {};
  }

  _createClass(Bridge, [{
    key: "setConfig",
    value: function setConfig(config) {
      this.config = config;
    }
  }, {
    key: "getConfig",
    value: function getConfig(item) {
      return this.config[item];
    }
  }, {
    key: "getRAWConfig",
    value: function getRAWConfig() {
      return this.config;
    }
  }, {
    key: "setContextHandlers",
    value: function setContextHandlers(handlers) {
      this.contextHandlers = handlers;
    }
  }, {
    key: "getContextHandlers",
    value: function getContextHandlers() {
      return this.contextHandlers;
    }
  }]);

  return Bridge;
}();

var _default = new Bridge();

exports.default = _default;